import { Listing } from '../types';
// Shared .mjs so the wizard, the listing card and the build scripts all score
// a profile identically — allowJs resolves it for TypeScript.
import { evaluateCompleteness, listingToProfile, AI_READY_SCORE } from './listingCompleteness.mjs';

/**
 * Percentage completeness of a venue profile (0-100).
 *
 * The rules live in utils/listingCompleteness.mjs; this stays as the name the
 * rest of the app already imports. It used to hold its own copy of the
 * weights, which is how the wizard came to disagree with itself — see that
 * module's header for the two scoring rules it got backwards.
 */
export function calculateDataCompleteness(listing: Listing): number {
  return evaluateCompleteness(listingToProfile(listing)).score;
}

/** Does this profile earn the public AI READY badge? */
export function isAiReady(listing: Listing): boolean {
  return calculateDataCompleteness(listing) >= AI_READY_SCORE;
}

export { AI_READY_SCORE };
